import { Link, Outlet } from "react-router-dom";
import { Col, Container, Row, Nav, Navbar } from "react-bootstrap";
import { useAuth } from "../../utils/auth";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function Home() {

    const { t } = useTranslation();
    
    const MENU_ITEMS = [
        { name: t("navBarPending"), link: "/pending-surveys", notifications: undefined },
        { name: t("navBarDone"), link: "/done-surveys", notifications: undefined }
    ];

    const [selectedItem, setSelectedItem] = useState<string>("pending");

    useEffect(() => {
        const currentPath = location.pathname;
        const matchingItem = MENU_ITEMS.find((item) => item.link === currentPath);

        if (matchingItem) {
            setSelectedItem(matchingItem.link);
        } else {
            setSelectedItem("pending");
        }
    }, [location.pathname]);

    const handleMenuItemClick = (item: string) => {
        setSelectedItem(item);
    };

   

    return (
        
         <>
        <Row className="d-flex flex-wrap">
            <Col className="d-flex" style={{ padding: "0" }}>
                <Container>
                    <Row className="w-100 align-items-center" style={{ margin: "0" }}>

                        <Col xs={12} md={12} className="d-flex align-items-center" style={{ padding: "0" }}>
                            <img
                                src="/ilustracio-craiteria-public.png"
                                alt="Craiteria"
                                style={{ width: '240px', height: 'auto', objectFit: 'cover', backgroundColor: '#FFF' }}
                            />
                        </Col>
                        
                    </Row>
                    <Row className="w-100 align-items-center" style={{ margin: "0" }}>
                        <Container>
                            <Navbar bg="white" className="mt-3">
                                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                                <Navbar.Collapse id="basic-navbar-nav">
                                    <Nav className="me-auto w-90" variant="tabs" activeKey={MENU_ITEMS.findIndex(item => item.link === selectedItem)}>
                                        {MENU_ITEMS.map((item, index) => (
                                            <Nav.Link as={Link} to={`${item.link}`} key={index} eventKey={index} onClick={() => handleMenuItemClick(item.link)} style={{ color: item.link === selectedItem ? "green" : "black" }} className="position-relative">
                                                {item.name}
                                            </Nav.Link>
                                        ))}
                                    </Nav>

                                </Navbar.Collapse>
                            </Navbar>

                            <div className="d-flex justify-content-center  mt-3" >
                                <Outlet /> {/* Aqu� se renderizan las p�ginas internas del home */}
                            </div>
                        </Container>

                    </Row>
                </Container>
            </Col>
        </Row>
        </>
    );
   
   
}